
export function delay(delay: number) {
	return new Promise(resolve => setTimeout(resolve, delay));
}

export function emToPx(em: string | number): number {
	let bodyFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
	return parseFloat(em.toString()) * bodyFontSize;
}
